<template>
  <div>
    <div class="container">
      <div>

        <div class="header-container">
          <div class="mass-logo">
            <img src="https://mass.cloud.ut.ee/android-chrome-192x192.png" width="80" alt="MASS logo">
          </div>
          <div class="language-button dropdown">
            <img src='@/assets/translate.svg'/>
            {{ $t('language') }}
            <div class="dropdown-content">
              <LangSwitch/>
            </div>
          </div>
        </div>


        <h4 class="introduction-header">{{ $t('introduction.header') }}</h4>
        
        <div class="introduction-text">{{ $t('introduction.time_estimate') }}</div>
        <div class="introduction-text">{{ $t('introduction.evaluation') }}</div>
        <div class="introduction-text">{{ $t('introduction.apply') }}</div>

        <div class="introduction-text introduction-header">{{ $t('introduction.principles') }}</div>
        <div class="introduction-text">
          <div class="list-text">{{ $t('introduction.principle_1') }}</div>
          <div class="list-text">{{ $t('introduction.principle_2') }}</div>
          <div class="list-text">{{ $t('introduction.principle_3') }}</div>
          <div class="list-text">{{ $t('introduction.principle_4') }}</div>
        </div>

        <div class="introduction-text introduction-header">{{ $t('introduction.data_processing') }}</div>
        <div class="introduction-text">
          <div class="list-text">{{ $t('introduction.data_processing_1') }}</div>
          <div class="list-text">{{ $t('introduction.data_processing_2') }}</div>
          <div class="list-text">{{ $t('introduction.data_processing_3') }}</div>
          <div class="list-text">{{ $t('introduction.data_processing_4') }}</div>
          <div class="list-text">{{ $t('introduction.data_processing_5') }}</div>
        </div>
        <div class="introduction-text"/>
        <div class="introduction-text info-container">
          <div class="introduction-header" style="padding-top: 0px">{{ $t('introduction.contact') }}:</div>
          mari.seeba@ut.ee , mari.seeba@ria.ee
        </div>
        <div class="introduction-text info-container">
          <div class="introduction-header" style="padding-top: 0px">{{ $t('introduction.processor') }}</div>
          {{ $t('introduction.ut') }}
        </div>

        <div class="button-footer">
          <div class="navigation-buttons"/>

          <div class="navigation-buttons">
            <router-link :to="{ name: 'options' }">
              <button class="btn btn-outline-dark back" type="submit">
                {{ $t('continue') }}
              </button>
            </router-link>
          </div>
        </div>


        <div class="introduction-text more-info">{{ $t('introduction.developers') }}</div>
        <div class="introduction-text more-info">
        <img src='https://mirrors.creativecommons.org/presskit/buttons/88x31/png/by-nc.png' width="80"/>
        {{$t('cc')}}
        </div>

        <div class="image-container">

          <img v-if="$i18n.locale === 'en'" class="resize-eu" src='@/assets/EU_eng.png'/>

          <img v-else class="resize-eu" src='@/assets/EU_ee.png'/>

          <img class="resize" src='@/assets/Chess_logo_color_no_background.png'/>
        </div>
        <div class="disclaimer-text more-info">{{ $t('introduction.disclaimer') }}</div>

      </div>
    </div>
  </div>

</template>

<script>
import LangSwitch from "./LangSwitch";

export default {
  name: 'Introduction',
  components: {LangSwitch},
  data() {
    return {
      content: null,
    };
  },
  methods: {},
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.header-container {
  display: grid;
  grid-template-columns: 90fr 10fr;
}

.container {
  background-color: #ffff;
  padding: 1rem;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;

}

.dropdown {
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 15px 20px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.language-button {
  font-size: 0.8rem;
  width: 200px;
}

.info-container {
  display: flex;
  gap: 10px
}

.introduction-text {
  text-align: justify;
  padding-left: 5rem;
  padding-right: 5rem;
  padding-bottom: 1rem;
  font-size: 1rem;
}

.mass-logo {
  text-align: justify;
  padding-left: 5rem;
}

.list-text {
  text-align: left;
}

.introduction-header {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-weight: bolder;
}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  margin-top: 1rem;
  margin-right: 0px;
  padding: 0px 10px 10px 0;
}

.disclaimer-text {
  text-align: justify;
  padding: 2rem 5rem 1rem;
  font-size: 1rem;
}

.image-container {
  display: flex;
  gap: 5rem;
  justify-content: center;
  padding-bottom: 2rem;

}

img.resize {
  max-width: 20%;
}

img.resize-eu {
  max-width: 17%;
}

.navigation-buttons {
  padding-bottom: 4rem;
}

.more-info {
  font-size: 0.7rem !important;
}
</style>